module.exports = __webpack_public_path__ + "img/kia.79861c9d.png";